<!-- Vera – floating AI assistant launcher + chat sidebar -->
<div id="vera-fab-wrap" *ngIf="!isOpen && !hidden && !isFullPageRoute">
	<button id="vera-fab" (click)="toggle()" title="Ask Vera" type="button">
		<svg width="42" height="38" viewBox="0 0 215 192" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g transform="translate(100,96)">
				<circle cx="0" cy="0" r="78" fill="none" stroke="rgba(255,255,255,0.22)" stroke-width="12" />
				<circle cx="0" cy="0" r="32" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.22)" stroke-width="8" />
				<rect x="-9" y="-96" width="18" height="22" rx="4" fill="rgba(255,255,255,0.28)" />
				<rect x="-9" y="74" width="18" height="22" rx="4" fill="rgba(255,255,255,0.28)" />
				<rect x="74" y="-9" width="22" height="18" rx="4" fill="rgba(255,255,255,0.28)" />
				<rect x="-96" y="-9" width="22" height="18" rx="4" fill="rgba(255,255,255,0.28)" />
				<rect x="38" y="-88" width="18" height="22" rx="4" fill="rgba(255,255,255,0.28)" transform="rotate(45,38,-88)" />
				<rect x="-56" y="66" width="18" height="22" rx="4" fill="rgba(255,255,255,0.28)" transform="rotate(45,-56,66)" />
				<rect x="66" y="38" width="18" height="22" rx="4" fill="rgba(255,255,255,0.28)" transform="rotate(-45,66,38)" />
				<rect x="-88" y="-56" width="18" height="22" rx="4" fill="rgba(255,255,255,0.28)" transform="rotate(-45,-88,-56)" />
				<circle cx="0" cy="0" r="10" fill="#00b8a9" />
			</g>
			<rect x="24" y="52" width="152" height="20" rx="10" fill="white" opacity="0.9" />
			<rect x="40" y="80" width="120" height="18" rx="9" fill="#4da6f5" opacity="0.9" />
			<rect x="56" y="106" width="88" height="18" rx="9" fill="#00b8a9" />
			<rect x="72" y="132" width="56" height="16" rx="8" fill="rgba(0,184,169,0.45)" />
			<circle cx="100" cy="162" r="11" fill="#22c55e" />
			<circle cx="100" cy="162" r="6" fill="white" opacity="0.9" />
		</svg>
		<div>
			<div class="fab-label">Vera</div>
			<span class="fab-sub">LMS Assistant</span>
		</div>
		<div class="fab-pulse"></div>
	</button>
	<button id="vera-fab-hide" (click)="hideWidget($event)" title="Hide Vera assistant" type="button">
		<i class="bx bx-x"></i>
	</button>
</div>

<div id="vera-overlay" [class.open]="isOpen" (click)="close()"></div>

<div id="vera-panel" [class.open]="isOpen">
	<div class="vera-hdr">
		<div class="vera-hdr-left">
			<div class="vera-hdr-icon">
				<svg width="30" height="27" viewBox="0 0 215 192" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g transform="translate(100,96)">
						<circle cx="0" cy="0" r="78" fill="none" stroke="rgba(255,255,255,0.25)" stroke-width="12" />
						<circle cx="0" cy="0" r="32" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.25)" stroke-width="8" />
						<rect x="-9" y="-96" width="18" height="22" rx="4" fill="rgba(255,255,255,0.3)" />
						<rect x="-9" y="74" width="18" height="22" rx="4" fill="rgba(255,255,255,0.3)" />
						<rect x="74" y="-9" width="22" height="18" rx="4" fill="rgba(255,255,255,0.3)" />
						<rect x="-96" y="-9" width="22" height="18" rx="4" fill="rgba(255,255,255,0.3)" />
						<rect x="38" y="-88" width="18" height="22" rx="4" fill="rgba(255,255,255,0.3)" transform="rotate(45,38,-88)" />
						<rect x="-56" y="66" width="18" height="22" rx="4" fill="rgba(255,255,255,0.3)" transform="rotate(45,-56,66)" />
						<rect x="66" y="38" width="18" height="22" rx="4" fill="rgba(255,255,255,0.3)" transform="rotate(-45,66,38)" />
						<rect x="-88" y="-56" width="18" height="22" rx="4" fill="rgba(255,255,255,0.3)" transform="rotate(-45,-88,-56)" />
						<circle cx="0" cy="0" r="10" fill="#00b8a9" />
					</g>
					<rect x="24" y="52" width="152" height="20" rx="10" fill="white" opacity="0.8" />
					<rect x="40" y="80" width="120" height="18" rx="9" fill="#4da6f5" opacity="0.85" />
					<rect x="56" y="106" width="88" height="18" rx="9" fill="#00b8a9" />
					<rect x="72" y="132" width="56" height="16" rx="8" fill="rgba(0,184,169,0.4)" />
					<circle cx="100" cy="162" r="11" fill="#22c55e" />
					<circle cx="100" cy="162" r="6" fill="white" opacity="0.9" />
				</svg>
			</div>
			<div>
				<div class="vera-hdr-title">Vera</div>
				<div class="vera-hdr-sub">LMS Assistant</div>
			</div>
		</div>
		<div class="vera-hdr-actions">
			<button class="vera-close" title="New conversation" (click)="newConversation()" type="button">✦</button>
			<button class="vera-close" title="Expand view" (click)="expand()" type="button">⤢</button>
			<button class="vera-close" title="Close" (click)="close()" type="button">✕</button>
		</div>
	</div>

	<div class="vera-msgs">
		<div class="vera-msg" *ngFor="let m of messages; trackBy: trackByIndex" [class.user]="m.role === 'user'" [class.assistant]="m.role === 'assistant'">
			<div class="vera-bubble" [innerHTML]="render(m.text)"></div>
			<div class="vera-options" *ngIf="m.options?.length">
				<button
					class="vera-option-btn"
					*ngFor="let option of m.options"
					(click)="selectOption(m, option)"
					[disabled]="loading || m.optionsResolved"
					type="button"
				>
					{{ optionLabel(option) }}
				</button>
			</div>
			<div class="vera-msg-time">{{ m.time }}</div>
		</div>
		<div class="vera-msg assistant" *ngIf="loading">
			<div class="vera-typing"><span></span><span></span><span></span></div>
		</div>
		<div #messagesEnd></div>
	</div>

	<div class="vera-chips" *ngIf="messages.length <= 1">
		<div class="vera-chip" *ngFor="let chip of suggestionChips" (click)="sendChip(chip)">{{ chip }}</div>
	</div>

	<div class="vera-input-row">
		<textarea
			class="vera-input"
			rows="1"
			placeholder="Ask Vera..."
			[(ngModel)]="draft"
			name="veraDraft"
			(keydown)="onInputKeydown($event)"
		></textarea>
		<button class="vera-send" (click)="send()" [disabled]="loading || !draft.trim()" type="button">↑</button>
	</div>
</div>
